import { render, staticRenderFns } from "./UploadGlosasModal.vue?vue&type=template&id=448c722a"
import script from "./UploadGlosasModal.vue?vue&type=script&lang=js"
export * from "./UploadGlosasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports